/**
 * Leaves the SPA for an external checkout or hosted page.
 *
 * Kept in one helper so tests can intercept it without trying to redefine
 * jsdom's non-configurable Location methods.
 */
export function openExternalUrl(url: string): void {
  if (typeof window === 'undefined') return;
  window.location.assign(url);
}
